export function formatAttachment(attachment: string): string {
    return attachment.split('?sv=')[0].split('/').pop() ?? '';
}
